import React from 'react';
import './blog.scss';
import BlogCard from './BlogCard';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const Blogs = ({ blogs, title, showViewAll }) => {
  return (
    <div className="blogs">
      <div className="justify-content--space-between">
        <div className="blogs--title vxl-section-title">{title}</div>
        {showViewAll && (
          <Link to="/blogs" className="button action-link more">
            View All
          </Link>
        )}
      </div>
      <div className="blogs--container">
        {blogs.map(blog => (
          <BlogCard key={blog.blogId} blog={blog} />
        ))}
      </div>
    </div>
  );
};

Blogs.propTypes = {
  blogs: PropTypes.arrayOf(PropTypes.object).isRequired,
  title: PropTypes.string,
  showViewAll: PropTypes.bool,
};
Blogs.defaultProps = {
  title: 'Catch Our Blog & Updates',
  showViewAll: true,
};

export default Blogs;
